import React from "react";
import { useAuth } from "../../context/authCore";

const UserDetails: React.FC = () => {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div style={{ color: "#fff", padding: "0.25rem 0" }}>
      <div style={{ fontWeight: 700 }}>{user.displayName || "-"}</div>
      <div
        style={{
          color: "#c7cbd1",
          fontSize: "0.9rem",
          overflowWrap: "break-word",
        }}
      >
        {user.email || ""}
      </div>
    </div>
  );
};

export default UserDetails;
